import React, { ReactNode } from 'react'
import { Button } from '@material-ui/core'
import { DangerButton } from '../DangerButton'
import { H2 } from '../StyledText'
import { StyledDialog } from './styled'

interface IModal {
  open: boolean
  title: string
  children: ReactNode
  id?: string
  type?: 'info' | 'confirm' | 'activeConfirm'
  actionLabel?: string
  cancelLabel?: string
  action?: () => void
  handleClose(): void
}

export const Modal = ({
  id,
  open,
  type,
  handleClose,
  actionLabel = 'Ok',
  cancelLabel = 'Cancel',
  title,
  action,
  children,
}: IModal) => (
  <StyledDialog
    id={id}
    maxWidth="xs"
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <H2 id="alert-dialog-title" className="title">
      {title}
    </H2>
    <div id="alert-dialog-description" className="content">
      {children}
    </div>
    <div className="actions">
      {type === 'info' && (
        <Button
          id="action-button"
          onClick={handleClose}
          color="primary"
          variant="contained"
        >
          Ok
        </Button>
      )}
      {type === 'activeConfirm' && (
        <>
          <DangerButton
            id="cancel-button"
            className="cancel-button"
            onClick={handleClose}
            variant="contained"
          >
            {cancelLabel}
          </DangerButton>
          <Button
            id="action-button"
            onClick={action}
            color="primary"
            variant="contained"
            autoFocus
          >
            {actionLabel}
          </Button>
        </>
      )}
      {(!type || type === 'confirm') && (
        <>
          <Button id="action-button" onClick={action}>
            {actionLabel}
          </Button>
          <DangerButton
            id="cancel-button"
            className="cancel-button"
            onClick={handleClose}
            variant="contained"
            autoFocus
          >
            {cancelLabel}
          </DangerButton>
        </>
      )}
    </div>
  </StyledDialog>
)
